export default [
  {
    name: '',
    route: '',
    title: '首页',
  },
  {
    name: 'Models',
    route: '/models',
    title: '模型',
  },
  {
    name: 'Map',
    route: '/map',
    title: '地图',
  },
  {
    name: 'Users',
    route: '/users',
    title: '用户',
  },
  {
    name: 'AR',
    route: '/ar',
    title: 'AR',
  },
  {
    name: 'MapAlignment',
    route: '/AlignmentList',
    title: 'MapAlignment',
  },
  {
    name: 'pcr',
    route: '/pcr',
    title: 'PCR',
  },
  {
    name: 'pad-version',
    route: '/pad-version',
    title: 'PAD版本',
  },
];
